<template>
    <div>
        <div id="deliveryLocationSelctionModalOverlay">
        </div>
        <div id="deliveryLocationsSelectionDisplayDiv">
            <div id="deliveryLocationsHeader">
                <div id="deliveryLocationsCloseButon" @click="closeDeliverySelection">
                    X
                </div>
                Select A Distribution Center
            </div>

                <div id="loctionDisplayColumnTitles" class="deliveryLocationDisplayWrapper titleDiv">
                    <div class="deliveryLocationTitleDisplay">
                    <div id="distanceTitle" class="deliverySiteDistanceFromDestZipDiv">
                        Miles

                        <span class="sortByDirectionDiv" @click="reSortDeliveryLocations('distance')">
                            <div id="distance" class="orderArrow" :class="[(adesaSort.direction == 'ASC' && adesaSort.field == 'distance') ? 'asc' : 'desc', adesaSort.field == 'distance' ? 'highlight' : '']">
                                &#10094;
                            </div>
                        </span>
                    </div>
                    <div id="siteNameTitle" class="deliverySiteNameDiv">
                        Name

                        <span class="sortByDirectionDiv" @click="reSortDeliveryLocations('site_name')">
                            <div id="site_name" class="orderArrow" :class="[(adesaSort.direction == 'ASC' && adesaSort.field == 'site_name')? 'asc' : 'desc', adesaSort.field == 'site_name' ? 'highlight' : '']">
                                &#10094;
                            </div>
                        </span>
                    </div>
                    <div id="siteAddressTitle" class="deliverySiteAddressDiv">
                        Address
                    </div>
                    <div id="glassTravelingShowroomTitle" class="glassTravelingShowroomDiv">
                    </div>
                    </div>
                </div>
            <div id="deliveryLocationSelectionWrapper">
                <div :id="location.zip" v-for="(location, index) in orderedLocations" :key="index" :location="location" class="deliveryLocationDisplayWrapper" @click="selectDeliveryLocation(index)">
                    <div :class="['deliveryLocationDisplay', selectedLocation.site_name == location.site_name ? 'current' : '']">
                        <div class="deliverySiteDistanceFromDestZipDiv">
                            {{ Math.round(location.distance) }}
                        </div>
                        <div class="deliverySiteNameDiv">
                            {{ location.site_name }}
                        </div>
                        <div class="deliverySiteAddressDiv">
                            <div class="deliverySiteStreetInfoDiv">
                                {{ location.street_number }} {{ location.street_name }}
                            </div>
                            <div id="deliverySiteCityStateZip">
                                {{ location.city }}, {{ location.state }} {{ location.zip }}
                            </div>
                        </div>
                        <div class="glassTravelingShowroomDiv">
                            <img v-if="location.has_glass_traveling_showroom == 1" class="glassTravelingShowroomIcon" src="@/assets/glassTravelingShowroomIcon.jpg"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            orderedLocations() {
                return this.$store.getters.getDeliveryLocationsSorted;
            },
            selectedLocation() {
                return this.$store.getters.getDefaultDeliveryLocation;
            },
            adesaSort() {
                return this.$store.getters.getDeliveryLocationSortBy;
            }
        },
        methods: {
            selectDeliveryLocation(index) {
                if (this.$store.getters.getDeliveryLocations[index].site_name != this.selectedLocation.site_name) {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('select', {'event_category': 'delivery_location_select','event_label': eventLabel});
                    this.$store.commit('setSelectedDeliveryLocation', this.orderedLocations[index]); //index);
                    this.closeDeliverySelection();
                }
            },
            closeDeliverySelection() {
                this.$store.commit('setDeliveryLocationSelectOpenStatus', false);
            },
            reSortDeliveryLocations(sortField) {
                let direction = this.adesaSort.field != sortField ? 'ASC' : (this.adesaSort.direction == 'ASC' ? 'DESC' : 'ASC');
                let newSort = { field: sortField, direction: direction };
                this.$store.commit('setDeliveryLocationSort', newSort);
            }
        }
    }
</script>

<style>
    #deliveryLocationSelctionModalOverlay {
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        background-color: black;
        opacity: .6;
    }

    #deliveryLocationsSelectionDisplayDiv {
        position: fixed;
        z-index: 3;
        top: calc(5 * var(--vh));
        left: calc(25 * var(--vw));
        height: calc(90 * var(--vh));
        width: calc(50 * var(--vw));
        background-color: #DFDFDF;
        color: black;
    }

    .inmobile #deliveryLocationsSelectionDisplayDiv {
        top: calc(1 * var(--vh));
        left: calc(1 * var(--vw));
        height: calc(98 * var(--vh));
        width: calc(98 * var(--vw));
    }

    #deliveryLocationsHeader {
        height: calc(6 * var(--vh));
        width: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.4em;
    }

    .inmobile #deliveryLocationsHeader {
        height: calc(10 * var(--vh));
    }

    #deliveryLocationsCloseButon {
        position: absolute;
        top: calc(1 * var(--vw));
        right: calc(1 * var(--vw));
        font-size: .8em;
        cursor: pointer;
    }

    .inmobile #deliveryLocationsCloseButon {
        top: calc(1 * var(--vh));
        right: calc(1 * var(--vh));
    }

    .inmobile #deliveryLocationsHeader {
        font-size: 1.65em;
    }

    #deliveryLocationSelectionWrapper {
        height: calc(78 * var(--vh));
        width: inherit;
        overflow-y: scroll;
        border-radius: 5px;
    }

    .inmobile #deliveryLocationSelectionWrapper {
        height: calc(78 * var(--vh));
    }

    .deliveryLocationDisplayWrapper {
        width: inherit;
        height: calc(6 * var(--vh));
        border: solid black .25px;
        border-radius: 5px;
    }

    .inmobile .deliveryLocationDisplayWrapper {
        width: calc((98 * var(--vw)) - .5px);
        height: calc(10 * var(--vh));
    }

    .deliveryLocationDisplayWrapper:hover {
        border-color: var(--mccluskeyGold); /*#AF873F;*/
    }

    .deliveryLocationDisplayWrapper.titleDiv:hover {
        border-color: black;
    }

    .deliveryLocationDisplayWrapper > .current {
        border-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
    }

    .deliveryLocationDisplay, .deliveryLocationTitleDisplay {
        height: inherit;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }

    /*.inmobile .deliveryLocationDisplay {
        flex-direction: column;
    }*/

    .deliveryLocationDisplay.current {
        color: var(--mccluskeyBlue);/*#0077C0;*/ /*#0079B6;*/
    }

    .deliveryLocationDisplay:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        cursor: pointer;
    }

    .deliverySiteDistanceFromDestZipDiv {
        font-weight: bolder;
        font-size: 1.15em;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10%;
    }

    .inmobile .deliverySiteDistanceFromDestZipDiv {
        font-size: inherit;
    }

    .deliverySiteNameDiv {
        font-weight: bolder;
        font-size: 1.15em;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40%;
    }

    .inmobile .deliverySiteNameDiv {
        font-size: inherit;
    }

    .deliverySiteAddressDiv {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 1.15em;
    }

    .inmobile .deliverySiteAddressDiv {
        font-size: inherit;
    }

    .glassTravelingShowroomDiv {
        width: 10%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .glassTravelingShowroomIcon {
        width: calc(4.5 * var(--vw));
        border-radius: 10px;
    }

    .inmobile .glassTravelingShowroomIcon {
        width: calc(9 * var(--vw));
    }

    .sortByDirectionDiv {
        height: inherit;
        width: calc(1.5 * var(--vh));
        margin: calc(.3 * var(--vh));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sortByDirectionDiv:hover {
        cursor: pointer;
    }

    .orderArrow {
        transition: transform 2s;
    }

    .asc {
        transform: rotate(90deg);
    }

    .desc {
        transform: rotate(-90deg);
    }

    .highlight {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>